export const ADMIN_API_BASE = "/api/admin";

export type LoadState<T> =
  | { status: "loading"; data?: undefined; error?: undefined }
  | { status: "loaded"; data: T; error?: undefined }
  | { status: "error"; data?: undefined; error: string };

export async function fetchAdminJson<T>(path: string): Promise<T> {
  const response = await fetch(`${ADMIN_API_BASE}${path}`, {
    credentials: "include",
    headers: {
      Accept: "application/json",
    },
  });

  if (response.status === 401) {
    throw new Error("Admin authentication required. Reload and sign in when prompted.");
  }

  if (!response.ok) {
    const body = await response.text();
    throw new Error(body || `Admin API request failed (${response.status})`);
  }

  return (await response.json()) as T;
}

export function currentSearch(): string {
  return window.location.search || "";
}
